<template>
	<div class="overview">
		<div class="total">{{ $t('当前共有') }}<span>{{ total }}</span>{{ $t('条记录') }}</div>
		<div class="amount" v-if="active == 2">
			<div class="rowItem">
				<div>{{ $t('已借金额') }}(USDT)</div>
				<div>{{ objectS.borrow }}</div>
			</div>
			<div class="rowItem">
				<div>{{ $t('剩余还币数量') }}(USDT)</div>
				<div>{{ objectS.repay }}</div>
			</div>
			<div class="rowItem">
				<div>{{ $t('已还') }}(USDT)</div>
				<div>{{ objectS.pecent }}</div>
			</div>
		</div>
		<div class="table" v-if="active == 0 || active == 1">
			<!-- 表头 -->
			<el-row class="header">
				<el-col :span="6" class="elItem">{{ $t('时间') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('币种') }}</el-col>
				<el-col :span="5" class="elItem">{{ $t('数量') }}</el-col>
				<el-col :span="5" class="elItem">{{ $t('手续') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('状态') }}</el-col>
			</el-row>
			<!-- 数据 -->
			<div class="scroll">
				<el-row v-for="item in orderList" :key="item.id" class="row">
					<el-col :span="6" class="trade">
						{{ item.createtime_text }}
					</el-col>
					<el-col :span="4" class="trade">
						<div v-if="active == 0">
							{{ item.unit_received }}
						</div>
						<div v-if="active == 1">
							{{ item.unit }}
						</div>
					</el-col>
					<el-col :span="5" class="trade">
						{{ item.amount_received }}
					</el-col>
					<el-col :span="5" class="trade">
						{{ item.fee }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.status_text }}
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="table" v-if="active == 2">
			<!-- 表头 -->
			<el-row class="header">
				<el-col :span="4" class="elItem">{{ $t('借币数量') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('验资金额') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('日币利息') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('当前币息') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('总服务费') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('应还总额') }}</el-col>
			</el-row>
			<!-- 数据 -->
			<div class="scroll">
				<el-row v-for="item in orderList" :key="item.id" class="row">
					<el-col :span="4" class="trade">
						{{ item.amount }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.money }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.daily_interest_rate }}%
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.interest_amount }}%
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.service_charge }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.all_money }}
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="table" v-if="active == 3">
			<!-- 表头 -->
			<el-row class="header">
				<el-col :span="4" class="elItem">{{ $t('币种') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('方向') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('总数量') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('委托价格') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('成交价格') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('类型') }}</el-col>
			</el-row>
			<!-- 数据 -->
			<div class="scroll">
				<el-row v-for="item in orderList" :key="item.id" class="row">
					<el-col :span="4" class="trade">
						{{ item.title }}
					</el-col>
					<el-col :span="4" class="trade" style="color: aqua;">
						{{ item.direction_text }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.number }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.limit_price }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.amount }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.type_text }}
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="table" v-if="active == 4">
			<!-- 表头 -->
			<el-row class="header">
				<el-col :span="4" class="elItem">{{ $t('币种') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('机器人ID') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('投入金额') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('总收益') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('网格数量') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('服务费') }}</el-col>
			</el-row>
			<!-- 数据 -->
			<div class="scroll">
				<el-row v-for="item in orderList" :key="item.id" class="row">
					<el-col :span="4" class="trade">
						{{ item.name }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.id }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.amount }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.totalincome }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.number }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.commission }}
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="table" v-if="active == 5">
			<!-- 表头 -->
			<el-row class="header">
				<el-col :span="4" class="elItem">{{ $t('币种') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('方向') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('委托总量') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('委托价格') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('手续费') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('成交均价') }}</el-col>
			</el-row>
			<!-- 数据 -->
			<div class="scroll">
				<el-row v-for="item in orderList" :key="item.id" class="row">
					<el-col :span="4" class="trade">
						{{ item.title }}
					</el-col>
					<el-col :span="4" class="trade" style="color: aqua;">
						{{ item.direction_text }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.quantity }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.amount }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.fee }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.charge_price }}
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="table" v-if="active == 6">
			<!-- 表头 -->
			<el-row class="header">
				<el-col :span="7" class="elItem">{{ $t('投资组合') }}</el-col>
				<el-col :span="7" class="elItem">{{ $t('申请金额') }}</el-col>
				<el-col :span="5" class="elItem">{{ $t('当前收益') }}</el-col>
				<el-col :span="5" class="elItem">{{ $t('状态') }}</el-col>
			</el-row>
			<!-- 数据 -->
			<div class="scroll">
				<el-row v-for="item in orderList" :key="item.id" class="row">
					<el-col :span="7" class="trade">
						{{ item.title }}
					</el-col>
					<el-col :span="7" class="trade" style="color: aqua;">
						{{ item.amount }}
					</el-col>
					<el-col :span="5" class="trade" style="color: aqua;">
						{{ item.profit }}
					</el-col>
					<el-col :span="5" class="trade">
						{{ item.status }}
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>


<script>
export default {
	props: {
		orderList: {
			type: Array,
			default: () => []
		},
		objectS: {
			type: Object,
			default: () => { }
		},
		active: {
			type: Number,
			default: 0
		},
		total: {
			type: Number,
			default: 0
		},
	},
	components: {},
	data() {
		return {};
	},
	mounted() { },

	methods: {}
};
</script>
<style lang="scss" scoped>
.overview {
	padding: 10px 0;
	padding-bottom: 0;

	.amount {
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		padding: 10px 0;
		margin-top: 10px;
		font-size: 14px;

		.rowItem {
			text-align: center;

			div:nth-child(2) {
				padding-top: 4px;
				font-size: 20px;
			}
		}
	}

	.total {
		color: #888;

		span {
			color: #fff;
			padding: 0 4px;
		}
	}

	.table {
		color: #fff;
		margin-top: 10px;
		font-size: 14px;
		border-bottom: 1px solid #2b2b3d;

		.header {
			padding: 10px 0;
			border-bottom: 1px solid #222b39;

			.elItem {
				text-align: center;
			}
		}

		// .scroll {
		// 	overflow-y: auto;
		// 	height: 52vh;
		// 	scrollbar-width: none;
		// 	/* Firefox */
		// 	-ms-overflow-style: none;
		// 	/* IE/Edge */
		// }

		.row {

			padding: 10px 0px;
			display: flex;
			align-items: center;
			font-size: 16px;

			.trade {
				text-align: center;
			}

			.rowItem {
				display: flex;
				align-items: center;
			}


		}
	}

}
</style>